<template>
  <div>
    <breadcrumb :items="breadcrumbs"></breadcrumb>
    <v-container fluid>
      <v-row class="mb-4 mx-1">
        <v-col cols="6">
          <div class="d-flex flex-row">
            <h2 class="mb-2 mr-4">{{ $t("ration.ingredientLibrary") }}</h2>
          </div>
        </v-col>
      </v-row>
      <v-card class="mx-4">
        <v-card-text>
          <v-data-table
            :headers="tableHeaders"
            :items="ingredientLibraries"
            :header-props="{
              'sort-icon': 'mdi-unfold-more-horizontal',
            }"
            :loading="$apollo.loading"
            :hide-default-footer="true"
            :options.sync="tableOptions"
            :items-per-page="itemsPerPage"
            class="ma-3"
          >
            <template v-slot:top>
              <div class="d-flex mt-5">
                <v-text-field
                  append-icon="mdi-magnify"
                  outlined
                  height="5px"
                  :placeholder="$t('feedMgt.searchByFeedName')"
                  dense
                  v-model="search"
                  class="shrink"
                >
                </v-text-field>
                <!-- <v-btn
                  :disabled="search.length < 1"
                  color="primary"
                  height="40"
                  width="40"
                  max-width="40"
                  outlined
                  class="ml-4 mr-4"
                  @click="searchUsers"
                >
                  <v-icon>mdi-filter-outline</v-icon>
                </v-btn> -->
                <!-- <v-select
                  outlined
                  dense
                  placeholder="Select Individual Animal(s)"
                  class="shrink"
                ></v-select> -->
                <v-spacer></v-spacer>
                <div class="py-3">
                  {{ from }} - {{ to }} of {{ totalIngredients }}
                </div>
                <v-btn
                  class="mx-2"
                  fab
                  small
                  outlined
                  color="primary"
                  :disabled="tableOptions.page <= 1"
                  @click="pageChange(false)"
                >
                  <v-icon dark> mdi-chevron-left </v-icon>
                </v-btn>
                <v-btn
                  class="mx-2"
                  fab
                  small
                  outlined
                  color="primary"
                  :disabled="tableOptions.page >= totalPages"
                  @click="pageChange(true)"
                >
                  <v-icon dark> mdi-chevron-right </v-icon>
                </v-btn>
                <v-menu
                  v-model="menu"
                  :close-on-content-click="false"
                  :nudge-width="200"
                  left
                  :min-width="417"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      class="mx-2"
                      fab
                      small
                      outlined
                      color="primary"
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon dark> mdi-cog-outline</v-icon>
                    </v-btn>
                  </template>
                  <v-card width="417">
                    <v-list>
                      <v-list-item>
                        <v-list-item-content>
                          <v-list-item-title>{{
                            $t("farm.customization")
                          }}</v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                      <v-divider></v-divider>
                      <div class="pl-3 pt-2 font-weight-normal">
                        {{ $t("farm.recordsPerpage") }}
                      </div>
                      <v-list-item>
                        <v-list-item-content>
                          <v-slider
                            v-model="itemsPerPageSlider"
                            :tick-labels="itemsPerPageOptions"
                            :max="3"
                            step="1"
                            ticks="always"
                            tick-size="4"
                          ></v-slider>
                        </v-list-item-content>
                      </v-list-item>
                      <v-divider class="mt-n3"></v-divider>
                    </v-list>
                    <v-card-text>
                      <v-row>
                        <v-col
                          class="mt-n9"
                          cols="6"
                          v-for="header in headers"
                          :key="header.value"
                        >
                          <v-checkbox
                            v-if="header.value !== 'action'"
                            v-model="selectedHeaders"
                            :label="header.text"
                            color="primary"
                            :value="header.text"
                            hide-details
                            :disabled="
                              header.text == 'ID' || header.text == 'Tag'
                            "
                          ></v-checkbox>
                        </v-col>
                      </v-row>
                    </v-card-text>
                    <v-layout justify-center>
                      <v-card-actions class="mb-5">
                        <v-spacer></v-spacer>
                        <v-btn
                          outlined
                          color="primary"
                          @click="resetDefaut"
                          width="fit-content"
                        >
                          {{ $t("farm.restoreDefault") }}
                        </v-btn>
                        <v-btn
                          color="primary"
                          @click="resetTableStructure"
                          width="190"
                        >
                          {{ $t("farm.apply") }}
                        </v-btn>
                      </v-card-actions>
                    </v-layout>
                  </v-card>
                </v-menu>
              </div>
            </template>
            <template v-slot:progress>
              <v-progress-linear
                color="primary"
                :height="6"
                indeterminate
              ></v-progress-linear>
            </template>

            <!-- <template v-slot:item.action="{ item }">
              <v-icon @click="dummyFunc(item)">mdi-dots-vertical</v-icon>
            </template> -->
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-container>
  </div>
</template>
<script>
// import { debounce } from 'lodash';
import loadingMixin from "@/mixins/LoadingMixin";
import gql from "graphql-tag";
export default {
  apollo: {
    ingredientLibraries: {
      query: gql`
        query ingredientLibraries($queryData: GetQueryDataArgs!) {
          ingredientLibraries(queryData: $queryData) {
            count
            totalCount
            rows {
              id
              feedName
              feedClass
              group
              magnesium
              dm
              cp
              tdn
              ndf
              calcium
              phosphorous
            }
          }
        }
      `,
      fetchPolicy: "network-only",
      variables() {
        return {
          queryData: {
            page: this.tableOptions.page,
            limit: this.tableOptions.itemsPerPage,
            searchPhrase: this.search,
          },
        };
      },
      debounce: 1000,
      update: data => data.ingredientLibraries.rows,
      result({ data }) {
        this.totalIngredients = data.ingredientLibraries.totalCount;
        this.totalPages = Math.ceil(
          this.totalIngredients / this.tableOptions.itemsPerPage
        );
        this.from =
          (this.tableOptions.page - 1) * this.tableOptions.itemsPerPage + 1;
        this.to =
          this.tableOptions.page * this.tableOptions.itemsPerPage -
          (this.tableOptions.itemsPerPage - data.ingredientLibraries.count);
      },
    },
  },
  async mounted() {
    document.title = "Ingredient Library";
    this.selectedHeaders = this.headers.map(el => el.text);
    this.tableHeaders = this.headers;
  },

  watch: {
    tableOptions: {
      handler(nV, oV) {
        console.log(JSON.stringify(nV), "n");
        console.log(JSON.stringify(oV), "O");
      },
      deep: true,
    },
  },
  data() {
    return {
      tableHeaders: [],
      selectedHeaders: [],
      loading: true,
      breadcrumbs: [
        {
          text: this.$t("dashbaord"),
          disabled: false,
          to: "/",
        },
        {
          text: this.$t("Feed Management"),
          disabled: true,
          to: { name: "Feed Management" },
        },
        {
          text: this.$t("Ingredient Library"),
          disabled: true,
          to: "/ingredient-library",
        },
      ],
      tab: null,
      to: 0,
      from: 0,
      totalPages: "",
      totalCount: 0,
      itemsPerPage: 10,
      itemsPerPageSlider: 0,
      itemsPerPageOptions: [5, 10, 25, 50],

      transition: true,
      pageCount: 1,
      currentrows: 0,
      search: "",
      selected: [],

      totalIngredients: 1,
      selectedItem: false,
      tableOptions: { itemsPerPage: 10, page: 1 },
      tabletTableOptions: { itemsPerPage: 10, page: 1, sortBy: [] },
      headers: [
        {
          text: this.$t("feedMgt.feedNameScientificName"),
          align: "start",
          class: "black--text",
          value: "feedName",
        },
        {
          text: this.$t("feedClass"),
          value: "feedClass",
          class: "black--text",
        },
        {
          text: this.$t("animal.dashboardS.group"),
          value: "group",
          class: "black--text",
        },
        {
          text: "Mg",
          value: "mg",
          class: "black--text",
        },
        {
          text: "DM%",
          value: "dm",
          class: "black--text",
        },
        {
          text: "CP%",
          value: "cp",
          class: "black--text",
        },
        {
          text: "TDN%",
          value: "tdn",
          class: "black--text",
        },
        {
          text: "NDF%",
          value: "ndf",
          class: "black--text",
        },
        {
          text: "Calcium%",
          value: "calcium",
          class: "black--text",
        },
        {
          text: "Phosphoros%",
          value: "phosphoros",
          class: "black--text",
        },
        {
          text: "",
          value: "action",
          sortable: false,
        },
      ],
      existingLocationDialog: false,
      confirmationDialog: true,
      ingredientLibraries: [],
    };
  },

  methods: {
    // searchIngredientLibrary() {
    //   if (this.search == "") return;
    //   this.tableOptions.page = 1;
    //   this.getIngredientLibrary();
    // },
    resetDefaut() {
      this.tableHeaders = this.headers;
      this.selectedHeaders = this.headers.map(el => el.text);
      this.menu = false;
    },
    resetTableStructure() {
      this.startLoading();
      this.tableHeaders = this.headers.filter(header =>
        this.selectedHeaders.includes(header.text)
      );
      this.tableOptions.itemsPerPage =
        this.itemsPerPageOptions[this.itemsPerPageSlider];

      this.menu = false;
      // this.getfarm();
      this.stopLoading();
    },
    resetIngredientLibraryOnEmpty() {
      if (this.search === "") return;
      this.tableOptions.page = 1;
      this.getIngredientLibrary();
    },
    pageChange(t) {
      if (t) this.tableOptions.page = this.tableOptions.page + 1;
      else this.tableOptions.page = this.tableOptions.page - 1;
      this.$apollo.queries.ingredientLibraries.refetch();
    },
    dummyFunc(item) {
      console.log({ item });
    },
  },
  mixins: [loadingMixin],
  // apollo: {
  //   libraries: {
  //     query() {
  //       return gql`query`
  //     }
  //   }
  // }
};
</script>
<style lang="scss" scoped>
.border {
  border: 2px solid;
  border-color: #dae1ec;
}
.v-tab {
  text-transform: none !important;
}
</style>
